import {VNode} from "../../vm/vnode";

console.log('vdom',<div>AAA<Z/></div>)